import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { PageSection, SectionBody, SectionHeader } from './PageSection';
import { Box, Text, Heading } from 'grommet';
import Link from './Link';
import { navigate } from 'gatsby';

const StyledBlock = styled(Box)`
  background-color: ${({ theme }) => theme.global.colors['dark-2']};
  transition: background-color 0.3s ease;
  &:hover {
    color: white;
    background-color: ${({ theme }) => theme.global.colors.brand};
  }
`;

const Block = ({ title, ctaUrl, ctaLabel }) => {
  return (
    <StyledBlock onClick={() => navigate(ctaUrl)} pad={'2rem'} align={'center'}>
      <Box
        height={'100%'}
        direction={'column'}
        justify={'between'}
        align="center"
        width={'200px'}
      >
        <Box pad={{ bottom: '1rem' }}>
          <Heading level={'6'} color={'light-1'} textAlign={'center'}>
            {title}
          </Heading>
        </Box>

        <Text color={'light-1'}>
          <Link onDark href={ctaUrl}>
            {ctaLabel}
          </Link>
        </Text>
      </Box>
    </StyledBlock>
  );
};

const BlocksGrid = styled.div`
  display: grid;
  grid-auto-rows: auto;
  justify-content: center;
  grid-template-columns: repeat(auto-fit, minmax(245px, 0.25fr));
  grid-gap: calc(var(--gutters) * 2);
`;

const BlocksFlex = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  gap: 40px;
  justify-content: center;
`;

const BlocksSection = ({ title, items }) => {
  return (
    <PageSection>
      <SectionHeader title={title} />
      <SectionBody>
        <BlocksFlex>
          {items.map((item, index) => (
            <Block {...item} key={`${index}-${item.title} `} />
          ))}
        </BlocksFlex>
      </SectionBody>
    </PageSection>
  );
};

BlocksSection.propTypes = {};

export default BlocksSection;
